import angular from 'angular';
import _ from 'lodash';

const userContextServiceFactory = function userContextServiceFactory(NewTokenService, MerchantProfileStore) {
    'ngInject';
  return {
    getAccountLevel: function(){
      const userContext = NewTokenService.getUserContext();
      if(userContext.associatedWallets === undefined || userContext.associatedWallets === 'undefined' || userContext.associatedWallets === ''){
        return userContext.accountLevel; //case for consumer only
      } else {
        if(userContext.associatedWallets.length === 1){ // hybrid or merchant only
          return userContext.associatedWallets[0].accountLevel;
        } else {
          if(MerchantProfileStore.isMerchant() === true){ //2 profiles, logged as merchant
            const merchantprof = _.filter(userContext.associatedWallets, o =>
             { return (o.profile === "merchant" && o.temporary !== true);});
            return merchantprof[0].accountLevel;
          } else { //2 profiles, logged as consumer
            const consumerprof = _.filter(userContext.associatedWallets, o =>
             { return o.profile === "consumer";});
            return consumerprof[0].accountLevel;
          }
        }
      }
    },
    getMerchantLevel: function(){
      const userContext = NewTokenService.getUserContext();
      if(userContext.associatedWallets === undefined || userContext.associatedWallets === 'undefined' || userContext.associatedWallets === ''){
        return undefined;
      } else {
        if(userContext.associatedWallets.length === 1){ // hybrid or merchant only
          return userContext.associatedWallets[0].accountLevel;
        } else {
          const merchantprof = _.filter(userContext.associatedWallets, o =>
           { return (o.profile === "merchant" && o.temporary !== true);});
          return merchantprof[0].accountLevel;
        }
      }
    },
    getIdWallet: function(){
      const userContext = NewTokenService.getUserContext();
      if(userContext.associatedWallets === undefined || userContext.associatedWallets === 'undefined' || userContext.associatedWallets === ''){
        return userContext.idWallet; //case for consumer only
      } else {
        if(userContext.associatedWallets.length === 1){ // hybrid or merchant only
          return userContext.associatedWallets[0].idWallet;
        } else {
          if(MerchantProfileStore.isMerchant() === true){ //2 profiles, logged as merchant
            const merchantprof = _.filter(userContext.associatedWallets, o =>
             { return (o.profile === "merchant" && o.temporary !== true);});
            return merchantprof[0].idWallet;
          } else { //2 profiles, logged as consumer
            const consumerprof = _.filter(userContext.associatedWallets, o =>
             { return o.profile === "consumer";});
            return consumerprof[0].idWallet;
          }
        }
      }
    },
    getProfileType: function(){
      const userContext = NewTokenService.getUserContext();
      if(userContext.associatedWallets === undefined || userContext.associatedWallets === 'undefined' || userContext.associatedWallets === ''){
        return 'consumerOnly';
      } else {
        if(userContext.associatedWallets.length === 1){ // hybrid or merchant only
          if(MerchantProfileStore.isMerchantOnly()){
            return 'merchantOnly';
          } else {
            return 'consumerMerchant';
          }
        } else {
          return 'consumerMerchant';
        }
      }
    }
  };
}

export default userContextServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/userContextService.factory.js
 **/